import { Trans } from "@lingui/react/macro"
import "./MobileSearchMessaging.scss"

interface MobileSearchMessagingProps {
    numRooms: number
    keywords?: string
    onSearchOptionLinkClick: (ev: React.MouseEvent) => void
}

export function MobileSearchMessaging({
    numRooms,
    keywords,
    onSearchOptionLinkClick,
}: MobileSearchMessagingProps) {
    if (numRooms !== 0) {
        return null
    }
    return (
        <h2 className="MobileSearchMessaging">
            {keywords !== undefined ? (
                <Trans>
                    <span data-testid="no-rooms-available">
                        No search results for &lsquo;{keywords}&rsquo; match
                        your preferences, please update your{" "}
                        <a
                            id="search_filter_options_link"
                            href="#"
                            onClick={onSearchOptionLinkClick}
                        >
                            search/filter options.
                        </a>
                    </span>
                </Trans> // eslint-disable-line lingui/no-single-tag-to-translate
            ) : (
                <Trans>
                    No search results match your preferences, please update your{" "}
                    <a
                        id="search_filter_options_link"
                        href="#"
                        onClick={onSearchOptionLinkClick}
                    >
                        search/filter options.
                    </a>
                </Trans>
            )}
        </h2>
    )
}
